import { render, staticRenderFns } from "./RedFlag.vue?vue&type=template&id=3a19b939&lang=pug"
import script from "./RedFlag.vue?vue&type=script&lang=js"
export * from "./RedFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports